import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { CustomItem } from '../CustomItem';
import { PrivatePensionApplicationData } from '../PrivatePensionApplicationForm/constants';

export interface PrivatePensionApplicationSuccessProps {
  infos: PrivatePensionApplicationData;
  onClose: () => void;
}

export const PrivatePensionApplicationSuccess: React.FC<PrivatePensionApplicationSuccessProps> = ({
  infos,
  onClose,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
        <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']} alignItems="center">
          <UI.Icon size="xl" name="Success" color={Color['feedback.success.default']} />
          <UI.Text variant="semibold" fontSize={Typography['fontsize.lg']}>
            Solicitação realizada com sucesso.
          </UI.Text>
          <Stack w="full">
            <VStack
              space={Spacing['stack.xxs']}
              px={Spacing['inline.xxs']}
              py={Spacing['stack.xxxs']}
              borderRadius={BoxBorder.heavy}
              backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
              <VStack space={Spacing['stack.nano']}>
                <CustomItem label="Valor da solicitação:" value={Utils.Mask.Money(infos.value)} />
                <CustomItem
                  label="Data da solicitação:"
                  value={Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}
                />
                <CustomItem label="E-mail do cliente:" value={infos.clientEmail} />
                {!!infos.advisorEmail && (
                  <CustomItem label="E-mail do assessor:" value={infos.advisorEmail} />
                )}
              </VStack>
            </VStack>
          </Stack>
        </VStack>
      </UI.Shadow>
      <HStack alignSelf="end" space={Spacing['inline.xxxs']}>
        {onClose && <UI.Button onPress={onClose}>NOVA APLICAÇÃO</UI.Button>}
      </HStack>
    </VStack>
  );
};
